import { PureComponent } from 'react';

import withSettings, { IWithSettingsProps } from './withSettings';
import { ISettings } from '../../../lib/settings/types';

interface IOnSettingsChangedProps extends IWithSettingsProps {
  onChanged: (settings: ISettings, prevSettings: ISettings) => void;
}

class SettingsChangeListener extends PureComponent<IOnSettingsChangedProps> {
  componentDidUpdate(prevProps, prevState) {
    this.props.onChanged(this.props.settings, prevProps.settings);
  }

  render() {
    return null;
  }
}

export default withSettings(SettingsChangeListener);
